module.exports = __webpack_public_path__ + "img/banner-campaign-mobile.ddb71496.png";